import axios from 'axios'
import notifService from '../../services/notifService'

export const getRole = async ({ commit }, pagination) => {
  let res = await axios
    .get('/cms/roles', {
      params: pagination
    })
    .then(response => {
      commit('getRole', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })

  return res
}

export const addRole = async (_context, form) => {
  return await axios
    .post('/cms/roles', form)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const editRole = async (_context, form) => {
  return await axios
    .put('/cms/roles/edit/' + form.id, {
      name: form.name,
      guard_name: form.guard_name
    })
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const deleteRole = async (_context, val) => {
  return await axios
    .delete('/cms/roles/delete/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const getRoleList = async ({ commit }) => {
  let res = await axios
    .get('/cms/roles', {
      params: {
        per_page: 78
      }
    })
    .then(response => {
      commit('getRoleList', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const roleForm = ({ commit }, val) => {
  commit('roleForm', val)
}

export const roleFormReset = ({ commit }) => {
  commit('roleFormReset')
}

export const getPermission = async ({ commit }, pagination) => {
  let res = await axios
    .get('/cms/permissions', {
      params: pagination
    })
    .then(response => {
      commit('getPermission', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const addPermission = async (_context, form) => {
  let res = await axios
    .post('/cms/permissions', form)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })

  return res
}

export const editPermission = async (_context, form) => {
  let res = await axios
    .put('/cms/permissions/edit/' + form.id, {
      name: form.name,
      guard_name: form.guard_name,
      group_id: form.group_id
    })
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })
  return res
}

export const deletePermission = async (_context, val) => {
  let res = await axios
    .delete('/cms/permissions/delete/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return error
    })

  return res
}

export const permissionForm = ({ commit }, val) => {
  commit('permissionForm', val)
}

export const permissionFormReset = ({ commit }) => {
  commit('permissionFormReset')
}

// get role permission
export const getListPermission = async ({ commit }) => {
  let res = await axios
    .get('/cms/permissions/list')
    .then(response => {
      commit('getListPermission', response.data.data)
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })

  return res
}

export const getRolePermission = async ({ commit }, val) => {
  let res = await axios
    .get('/cms/roles/' + val + '/permission')
    .then(response => {
      commit('getRolePermission', response.data.data)
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })

  return res
}

export const setRolePermission = async (_context, val) => {
  return await axios
    .post('cms/roles/set/permissions', val)
    .then(response => {
      // commit('setRolePermission', response.data.data)
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const userRole = async (_context, val) => {
  return await axios
    .post('cms/roles/set/user', val)
    .then(response => {
      // commit('setRolePermission', response.data.data)
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}
